import { NavLink } from "@mantine/core";
import { type ReactNode } from "react";
import { Link, useLocation, useResolvedPath } from "react-router-dom";
import { useTranslation } from "react-i18next";
interface NavbarLinkProps {
  leftSection?: ReactNode;
  label: string;
  to: string;
  disabled?: boolean;
  onClickMobile?: VoidFunction;
}

export function NavbarLink({
  leftSection,
  label,
  to,
  onClickMobile,
  disabled = false,
}: NavbarLinkProps) {
  const { t } = useTranslation("common");
  const resolvedPath = useResolvedPath(to);
  const location = useLocation();
  const isActive = isMenuActive(resolvedPath.pathname, location.pathname);

  return (
    <NavLink
      ml={disabled ? 0 : 14}
      active={disabled ? false : isActive}
      component={Link}
      to={to}
      label={t(label)}
      leftSection={leftSection}
      disabled={disabled}
      onClick={onClickMobile}
    />
  );
}

function isMenuActive(basePath: string, currentPath: string) {
  const baseSegments = basePath
    .split("/")
    .filter(Boolean)
    .map((s) => s.toLowerCase());
  const currentSegments = currentPath
    .split("/")
    .filter(Boolean)
    .map((s) => s.toLowerCase());

  const matches = baseSegments.every((seg, i) => currentSegments[i] === seg);
  if (!matches) return false;

  const remainingSegments = currentSegments.slice(baseSegments.length);

  if (remainingSegments.length === 0) return true;

  if (
    remainingSegments.length === 1 &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      remainingSegments[0] ?? "",
    )
  ) {
    return true;
  }

  return false;
}
